import { API_RESOURCE } from '@/constants/api.constant'
import { axios } from '@/lib/axios'
import CrudService from '@/services/crudService'
import { createFormData } from '@/utils/api.util'

class OfferCostBudgetService extends CrudService {
  constructor() {
    super(API_RESOURCE.OFFER_COST_BUDGET)
  }

  toggleActiveOfferCostBudget = async ({ id, ...rest }) => {
    try {
      const response = await axios.put(`/${this.resource}/${id}/toggle-active`, rest)
      return response.data
    } catch (error) {
      console.error(`Error confirming offer cost budget with id ${id}`, error)
      throw error
    }
  }

  addProfileToAllUsers = async (id) => {
    try {
      const response = await axios.put(`/${this.resource}/${id}/add-to-users`)
      return response.data
    } catch (error) {
      console.error(`Error Adding offer cost budget to users with id ${id}`, error)
      throw error
    }
  }

  noticeProcurementOfficer = async ({ costBudgetId, ...data }) => {
    const response = await axios.put(`${this.resource}/${costBudgetId}/noticeProcurementOfficer`, data)

    return response.data
  }

  applySingleSource = async ({ costBudgetId, ...data }) => {
    const response = await axios.put(`${this.resource}/${costBudgetId}/applySingleSource`, data)

    return response.data
  }

  sendRFQ = async ({ costBudgetId, extraDocuments, ...data }) => {
    const formData = createFormData(data)

    for (const doc of extraDocuments) {
      formData.append('extraDocuments', doc)
    }

    // console.log(extraDocuments)
    // formData.forEach((value, key) => {
    //   console.log(key, value)
    // })

    // return []

    const response = await axios.put(`${this.resource}/${costBudgetId}/sendRFQ`, formData)

    return response.data
  }

  submitTenderDocumentToProcurement = async ({ costBudgetId, tenderDocumentIndex, ...data }) => {
    const response = await axios.put(
      `${this.resource}/${costBudgetId}/tenderDocuments/${tenderDocumentIndex}/submit`,
      data
    )

    return response.data
  }

  inactiveTenderDocument = async ({ costBudgetId, tenderDocumentIndex, ...data }) => {
    const response = await axios.put(`${this.resource}/${costBudgetId}/tenderDocuments/${tenderDocumentIndex}/inactive`)

    return response.data
  }

  activateTenderDocument = async ({ costBudgetId, tenderDocumentIndex, ...data }) => {
    const response = await axios.put(`${this.resource}/${costBudgetId}/tenderDocuments/${tenderDocumentIndex}/activate`)

    return response.data
  }

  startCostBudgetIssue = async ({ costBudgetId, ...data }) => {
    const response = await axios.post(`${this.resource}/${costBudgetId}/issues`, data)

    return response.data
  }

  replyCostBudgetIssue = async ({ costBudgetId, issueIndex, ...data }) => {
    const response = await axios.post(`${this.resource}/${costBudgetId}/issues/${issueIndex}`, data)

    return response.data
  }
  completeCostBudgetIssue = async ({ costBudgetId, issueIndex }) => {
    const response = await axios.put(`${this.resource}/${costBudgetId}/issues/${issueIndex}/complete`)

    return response.data
  }

  internalUploadCostBudgetQuotation = async ({ costBudgetId, ...rest }) => {
    const response = await axios.put(`${this.resource}/${costBudgetId}/uploadQuotation`, rest)

    return response.data
  }

  updateVendorHistory = async ({ costBudgetId, vendorIndex, ...rest }) => {
    const response = await axios.put(`${this.resource}/${costBudgetId}/vendors/${vendorIndex}/history`, rest)

    return response.data
  }

  updateVendorHistoryByIndex = async ({ costBudgetId, vendorIndex, historyIndex, ...rest }) => {
    const response = await axios.put(
      `${this.resource}/${costBudgetId}/vendors/${vendorIndex}/history/${historyIndex}`,
      rest
    )

    return response.data
  }

  downloadVendorHistory = async ({ costBudgetId, vendorIndex, ...rest }) => {
    const response = await axios.get(`${this.resource}/${costBudgetId}/vendors/${vendorIndex}/file`, {
      responseType: 'blob',
    })

    return response.data
  }

  getVendorDetail = async ({ costBudgetId, vendorIndex }) => {
    const response = await axios.get(`${this.resource}/${costBudgetId}/vendors/${vendorIndex}`)

    return response.data
  }

  getVendorHistory = async ({ costBudgetId, vendorIndex, historyIndex, offerId }) => {
    const response = await axios.get(
      `${this.resource}/${costBudgetId}/vendors/${vendorIndex}/history/${historyIndex}`,
      {
        params: { offerId },
      }
    )

    return response.data
  }
}

export default OfferCostBudgetService
